import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "flag-fill",
  "use": "flag-fill-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"flag-fill\"><path d=\"M3 1H1v14h2V1zm12.117 0H4v10h11.117a.5.5 0 00.429-.757l-2.392-3.986a.5.5 0 010-.514l2.392-3.986a.5.5 0 00-.43-.757z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol